import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import Responsive from "react-responsive";
import style from "./Toolbar.module.scss";

import SearchBox from "./SearchBox";
import Advanced from "./Advanced";

const Toolbar = ({ changeFilter, counters, search, changeSearch, filters }) => {
  const [range, setRange] = useState({
    from: filters.from,
    to: filters.to,
  });
  const [openAdvanced, setOpen] = useState(false);
  const applyChanges = () => changeFilter(range.from, range.to);

  return (
    <div className={style.toolbar}>
      <Row>
        <Col md={0} lg={3} xl={2}>
          {/* Totals */}
          <Counter {...counters} />
        </Col>
        <Col md={5} xl={6} lg={6}>
          {/* Search input and Advanced */}
          <div>
            <SearchBox
              changeValue={changeSearch}
              Desktop={Desktop}
              text={search}
              open={openAdvanced}
              toggleAdvanced={() => setOpen((o) => !o)}
            />

            <Advanced
              handleSearch={() => applyChanges()}
              toggle={() => setOpen((o) => !o)}
              handleChange={(name, value) =>
                setRange((r) => ({
                  ...r,
                  [name]: new Date(value).toLocaleDateString("en"),
                }))
              }
              from={range.from}
              to={range.to}
              open={openAdvanced}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

const Desktop = (props) => <Responsive {...props} minWidth={1000} />;

const Counter = ({ total, filtered }) => (
  <Desktop>
    <h6 className={`h6 page-title ${style.totals}`}>Recurring Commissions: {total}</h6>

    <div className="text-muted page-desc">{filtered} filtered</div>
  </Desktop>
);

export default Toolbar;
